export default {
  emptyHeader: 'No groups yet',
  emptySubtitle: "When you create groups, you'll see them here.",
};
